import { render, staticRenderFns } from "./AccountsSetup.vue?vue&type=template&id=5916d7e9&scoped=true&"
import script from "./AccountsSetup.vue?vue&type=script&lang=js&"
export * from "./AccountsSetup.vue?vue&type=script&lang=js&"
import style0 from "./AccountsSetup.vue?vue&type=style&index=0&id=5916d7e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916d7e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5916d7e9')) {
      api.createRecord('5916d7e9', component.options)
    } else {
      api.reload('5916d7e9', component.options)
    }
    module.hot.accept("./AccountsSetup.vue?vue&type=template&id=5916d7e9&scoped=true&", function () {
      api.rerender('5916d7e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/AccountsSetup.vue"
export default component.exports